var INITIALIZE_FETCHING = 'INITIALIZE_FETCHING';
var SET_ERROR = 'SET_ERROR';
var SET_DATA = 'SET_DATA';
var ACTION_TYPES = {
  SET_DATA: SET_DATA,
  SET_ERROR: SET_ERROR,
  INITIALIZE_FETCHING: INITIALIZE_FETCHING
};
export default ACTION_TYPES;